import { render, staticRenderFns } from "./addTermService.vue?vue&type=template&id=88ebbe8c&"
import script from "./addTermService.vue?vue&type=script&lang=js&"
export * from "./addTermService.vue?vue&type=script&lang=js&"
import style0 from "./addTermService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88ebbe8c')) {
      api.createRecord('88ebbe8c', component.options)
    } else {
      api.reload('88ebbe8c', component.options)
    }
    module.hot.accept("./addTermService.vue?vue&type=template&id=88ebbe8c&", function () {
      api.rerender('88ebbe8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/components/addTermService.vue"
export default component.exports